import { render, staticRenderFns } from "./CMJsonDetails.vue?vue&type=template&id=e6f1f770&scoped=true&"
import script from "./CMJsonDetails.vue?vue&type=script&lang=js&"
export * from "./CMJsonDetails.vue?vue&type=script&lang=js&"
import style0 from "./CMJsonDetails.vue?vue&type=style&index=0&id=e6f1f770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f1f770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6f1f770')) {
      api.createRecord('e6f1f770', component.options)
    } else {
      api.reload('e6f1f770', component.options)
    }
    module.hot.accept("./CMJsonDetails.vue?vue&type=template&id=e6f1f770&scoped=true&", function () {
      api.rerender('e6f1f770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/json/CMJsonDetails.vue"
export default component.exports